import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getAuthIsLoggedIn,
  getAuthRenderState,
  getAuthUser,
} from '@rd/core/auth/store/selectors/auth.selectors';
import { CoreState } from '@rd/core/store/reducers';
import { User } from '@rd/types/user.type';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  constructor(private store: Store<CoreState>) {}

  user$: Observable<User | null> = this.store.select(getAuthUser);

  isLoggedIn$: Observable<boolean> = this.store
    .select(getAuthIsLoggedIn)
    .pipe(map((value) => Boolean(value))); // Coerce null value to false

  authRenderState$ = this.store.select(getAuthRenderState);
}
